import {  mutate } from 'swr';
import { HprCacheKeys } from '../cacheKeys';
import { IPerson } from '../../models/IPerson';


export const usePersonCache = () => {

    const appendPersons = async (persons: IPerson[]) => {
        persons.forEach((person) => {
            mutate(HprCacheKeys.PersonInstance(person.id), person)
        });
    };

    const mutatePerson = async (person: IPerson) => {
        mutate(HprCacheKeys.PersonInstance(person.id), person)
    };

    const appendListPersons = async (persons: IPerson[]) => {
        persons.forEach((person) => {
            mutate(HprCacheKeys.PersonListInstance(person.id), person)
        });
    };

    return {
        appendPersons,
        mutatePerson,

        appendListPersons
    };
};
